// eslint-disable-next-line import/prefer-default-export
export const STATUS_SELECT_OPTIONS = [
	'DONE',
	'PLANNED'
]
